$(document).on('click', '.touch-menu', function(){
	$(this).toggleClass('on');
	$(".mob_menu").toggleClass('opened');
});